// Key the menu reports to Toolbar.Root; the picked colour id follows it.
export const PROJECT_COLOR_MENU_ID = 'color'

export const ADD_COLOR_ID = 'add'
// Row above the palette for an entity that borrows its colour from somewhere
// else, e.g. an arrow painted after its source (OCT-5222). Picking it reports
// an empty colour id.
export const INHERIT_ID = 'inherit'
export const MANAGE_ID = 'manage'
// All grey slots report the same id: any of them sells the plan.
export const PLACEHOLDER_ID = 'placeholder'

// Grey slots shown under the real colours to a user without the colour library.
export const PLACEHOLDER_COUNT = 6

// Gap between the picker and the plate edge, plus the 4px the button sits inside it.
export const PICKER_OFFSET_Y = 10
